import React, {useEffect, useState} from "react";
import {QuestionInputProps} from "../Question";
import {createUseStyles} from "react-jss";
import {TriviaStatus} from "../../../state/state";
import TextField from "engage-client/components/TextField";
import Button from "engage-client/components/Button";

const useStyles = createUseStyles({
	formControl: {
		width: "100%"
	},
	formLabel: {
		margin: [8,0]
	},
	buttonContainer: {
		textAlign: "right",
		margin: [8,0]
	}
});

export default function NumberInput({state, question, submitted, onSubmit}: QuestionInputProps) {
	const classes = useStyles();
	const [number, setNumber] = useState<number>();
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = parseFloat(e.target.value);
		if(isNaN(value)) {
			setNumber(undefined);
		} else {
			setNumber(value);
		}
	};

	useEffect(() => {
		if(state === TriviaStatus.QuestionStart) {
			setNumber(undefined);
		}
	}, [state]);

	return <div>
			<form onSubmit={(e) => {
				e.preventDefault();
				if (number !== undefined) {
					onSubmit(number);
				}
			}}>

					<TextField
						type="number"
						labelText="Value"
						value={number ?? ""}
						onChange={onChange}
						autoFocus
						disabled={submitted}
					 	name="numberInput"/>
				<div className={classes.buttonContainer}>
					<Button color="primary" type="submit" disabled={number === undefined || submitted}>Submit</Button>
				</div>
			</form>
	</div>;
}